import * as React from 'react';
import Link from 'next/link'
import { useSelector, useDispatch } from 'react-redux'

// styles
import { css } from "@emotion/react"
import colorPalette from '~/theme/colorPalette.js';
import { makeStyles } from '@material-ui/styles';
import { useTheme } from '@material-ui/core/styles';
import {
  Box,
  Drawer, NativeSelect,
  Typography
} from '@material-ui/core';

// resource
import { shopList } from '~/data/common/headerMenu'

// actions
import { toggleDrawer } from '~/slices/commons/drawer'

// components
import LinkButton from "../../../atoms/LinkButton";
import NeutralButton from "../../../atoms/NeutralButton";
import {ArrowRight} from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import {useWindowDimensions} from "../../../../services/hooks/common";
import CatalogCodeLabel from "../../../atoms/catalogCodeLabel";
import TempFrozen from "../../../../../public/images/common/temperature_frozen.svg";
import TempNormal from "../../../../../public/images/common/temperature_normal.svg";
import TrashIcon from "../../../../../public/images/common/trash.svg";
import {changeNum, removeItem} from "../../../../services/api/cart";
import {openBar} from "../../../../stores/slices/commons/snackbar";
import {hydrate} from "../../../../stores/slices/carts/cart";
import {findCategoryLabel, findSubCategoryLabel, findWithSubCategoryLabel} from "../../../../services/hooks/item";
import styled from "@emotion/styled";

// resources
// const useStyles = () => {
//   const theme = useTheme()
//   return makeStyles({
//     drawerPaper: {
//       [theme.breakpoints.up('md')]: {
//         width: '400px',
//         left: 'auto',
//         right: 'calc((100vw - 960px)/2)'
//       },
//     },
//   })
// }

// const theme = createTheme();
// const exportStyles = (theme) => {
//   const useStyles = makeStyles({
//     drawerPaper: {
//       [theme.breakpoints.up('md')]: {
//         width: '400px',
//         left: 'auto',
//         right: 'calc((100vw - 960px)/2)'
//       },
//       backgroundColor: '#000000',
//       height: '100vh',
//     },
//   })
//   console.log(useStyles)
//   return useStyles
// }

export default function CartDrawer(props) {
  const { width, height } = useWindowDimensions();
  const theme = useTheme()
  const useStyles = makeStyles({
    drawerPaper: {
      maxHeight: '90vh !important',
      [theme.breakpoints.up('md')]: {
        width: '430px',
        left: 'auto !important',
        right: 0
      },
      [theme.breakpoints.up('lg')]: {
        width: '430px',
        left: 'auto !important',
        right: `${width <= 960 ? 0 : 'calc((100vw - 960px)/2)'} !important`
      },
    },
  })
  
  const onChangeFunc = (e, code) => {
    const num = e.target.value
    changeNum(cartState.id, cartState.customerId, code, num).then(res => {
      dispatch(openBar({message: '数量を変更しました', variant: 'success'}))
      dispatch(hydrate(res.data))
    }).catch(() => {
      dispatch(openBar({message: '数量の変更に失敗しました', variant: 'error'}))
    })
  }
  
  const deleteCartItem = (code) => {
    removeItem(cartState.id, cartState.customerId, code).then(res => {
      dispatch(openBar({message: '商品を削除しました', variant: 'success'}))
      dispatch(hydrate(res.data))
    }).catch(() => {
      dispatch(openBar({message: '商品の削除に失敗しました', variant: 'error'}))
    })
  }

  const classes = useStyles()
  const { openFlg, key } = useSelector((state) => state.drawer)
  const dispatch = useDispatch()
  const loginState = useSelector((state) => state.login)
  const cartState = useSelector((state) => state.cart)

  const sumItemNum = (sum, current) => {
    return sum += current.num
  }

  return (
      <div>
        <Drawer
            anchor={'top'}
            open={openFlg && key == 'cart'}
            onClose={() => dispatch(toggleDrawer({openFlg: false, key: 'cart'}))}
            css={position}
            classes={{paper: classes.drawerPaper}}
        >
          <Box
              sx={{ width: 'auto' }}
              role="presentation"
              // onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'cart'}))}
              // onKeyDown={() => dispatch(toggleDrawer({openFlg: false, key: 'cart'}))}
              css={props.isSpacer ? marginTopAddSpacer : marginTop}
          >
            <Box css={cart}>
              <div css={{textAlign:'center', paddingBottom: '8px'}}>
                {
                  cartState.lines.length > 0 && cartState.lines[0].code !== null &&
                      <>
                        カートに <span css={{borderBottom: `solid 3px ${colorPalette.primary}`, fontSize: '1.2em', fontWeight: '500', padding: '0 3px'}}>{ cartState.lines.reduce(sumItemNum,0) }</span> 個の商品が入っています
                        <Typography variant={'body1'} css={{textAlign:'center'}}>
                          小計(税込)<span css={{fontSize: '1.8rem', margin: '0.5rem'}}>¥ { Number(cartState.totalDiscountPrice).toLocaleString() }</span>
                        </Typography>
                      </>
                    ||
                      <>
                        まだカートに商品が入っていません。
                      </>
                }
              </div>
              <Box className="inner-box">
                {
                  cartState.lines.length > 0 && cartState.lines[0].code !== null &&
                      <>
                        <ul css={cartLineStyle}>
                          {
                            cartState.lines.map((line, i) => (
                                <li key={`${line.code}_${i}`}>
                                  <div className={'lineBox'}>
                                    <div className={'itemInfo'}>
                                      <div className={'codeBox'}>
                                        <CatalogCodeLabel code={line.code} quantity={line.quantityTerms}/>
                                      </div>
                                      <CategoryTag color={line.majorCategory}>
                                        {
                                          line.majorCategory === 'selection' &&
                                          'セット商品'
                                          ||
                                              <>
                                                {
                                                  `${findWithSubCategoryLabel(line.category)?.label}`
                                                }
                                              </>
                                        }
                                      </CategoryTag>
                                      <div className={'other'}>
                                        {
                                          line.temperature === 'frozen' &&
                                          <TempFrozen css={tempIcon}/>
                                          ||
                                          <TempNormal css={tempIcon}/>
                                        }
                                      </div>
                                    </div>
                                    <div className={'itemName'}>
                                      {line.name}
                                    </div>
                                    <div className={'lineOperation'}>
                                      <TrashIcon css={trashIcon} onClick={() => deleteCartItem(line.code)}/>
                                      <div className={'price'}>
                                        ¥ {
                                          Number(line.discountPrice).toLocaleString()
                                        }
                                      </div>
                                      <div>
                                        <NativeSelect
                                            css={selectStyle}
                                            defaultValue={line.num || 0}
                                            inputProps={{
                                              name: 'item-num',
                                              id: 'uncontrolled-native',
                                            }}
                                            onChange={(e) => onChangeFunc(e, line.code)}
                                        >
                                          {
                                            [...Array(19)].map((_, i) => i).map((i) => (
                                                <option key={i+1} value={i+1}>{i+1}</option>
                                            ))
                                          }
                                        </NativeSelect>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                            ))
                          }
                        </ul>
                      </>
                }
              </Box>
            </Box>
            <Grid container spacing={1} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} css={{marginTop:'8px', marginBottom:'16px'}}>
              { shopList.map((obj, i) => (
                (obj.title === "お気に入り" || obj.title === "マイページ") &&
                  loginState.login &&
                    <Grid item key={i}>
                      <LinkButton
                          maxWidth={'240px'}
                          text={obj.title}
                          href={obj.path}
                          hexColorCode={colorPalette.gray}
                          prefetch={obj.prefetch}
                          endAdornment={<ArrowRight/>}
                          onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'cart'}))}
                      />
                    </Grid>
                ||
                  (obj.title === '会計へ進む') &&(
                    cartState?.totalPrice > 0 ?
                      <Grid item key={i}>
                        <LinkButton
                            maxWidth={'240px'}
                            text={obj.title}
                            href={obj.path}
                            hexColorCode={colorPalette.gray}
                            prefetch={obj.prefetch}
                            endAdornment={<ArrowRight/>}
                            onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'cart'}))}
                        />
                      </Grid>
                    :
                      <Grid item css={tooltip} key={i}>
                        <NeutralButton
                            text={obj.title}
                            hexColorCode={colorPalette.gray}
                            endAdornment={<ArrowRight/>}
                            disabled
                        />
                        <span className="tooltip-text">カートに商品がございません</span>
                      </Grid>
                  )
                ||
                  <Grid item key={i}>
                    <LinkButton
                        maxWidth={'240px'}
                        text={obj.title}
                        href={obj.path}
                        hexColorCode={colorPalette.gray}
                        prefetch={obj.prefetch}
                        endAdornment={<ArrowRight/>}
                        onClick={() => dispatch(toggleDrawer({openFlg: false, key: 'cart'}))}
                    />
                  </Grid>
              ))}
            </Grid>
          </Box>
        </Drawer>
      </div>
  );
}


const cart = css`
  width: 100%;
  margin: 0 auto;
  .title{
    font-weight: bold;
  }
  .inner-box{
    //height: 80px;
    background-color: ${colorPalette.background.lightgray};
    text-align: center;
    padding: 1rem;
    .inline{
      display: inline-block;
    }
    .explain{
      font-size: 1.2rem;
      font-weight: bold;
    }
    .link{
      font-weight: bold;
      color: ${colorPalette.orange};
      text-decoration: underline;
    }
  }
`

const position = css`
  z-index: 99;
  //.styledTab{
  //  left: auto;
  //  right: 65px;
  //  width: 300px;
  //}
  //.MuiDrawer-paper{
  //  left:auto;
  //  right: calc((100vw - 200px)/2);
  //  width: 320px;
  //}
`

const marginTop = css`
  padding-top: 80px;
`

const marginTopAddSpacer = css`
  padding-top: 122px;
`

const tooltip = css`
  position: relative;
  cursor: pointer;
  &:hover .tooltip-text {
    opacity: 1;
    visibility: visible;
  }
  .tooltip-text {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  right: 0%;
  transform: translateX(-50%);
  top: -5px;
  display: inline-block;
  padding: 5px;
  white-space: nowrap;
  font-size: 10.5px;
  line-height: 1.3;
  background: #333;
  color: #fff;
  border-radius: 3px;
  transition: 0.3s ease-in;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  /* &:before {
    content: '';
    position: absolute;
    bottom: -13px;
    left: 50%;
    margin-left: -7px;
    border: 7px solid transparent;
    border-bottom: 7px solid #333;
  } */
}
`;

const cartLineStyle = css`
  margin: 0;
  padding: 0;
  list-style: none;
  li {
  }
  .codeBox {
    max-width: 60px;
    flex-basis: 60px;
    margin-right: 8px;
    p {font-size: 1.4rem !important;}
  }
  .itemInfo {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 4px;
    .other {
      flex: 1;
      text-align: right;
    }
  }
  .itemName {
    flex: 1;
    text-align: left;
    p {font-size: 1.4rem !important;}
  }
  .lineBox {
    background-color: white;
    border-radius: 8px;
    width: 100%;
    padding: 8px;
    border-bottom: solid 1px ${colorPalette.lightgray};
  }
  .lineOperation {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-top: 0.5rem;
    .price {
      margin-left: 1rem;
      text-align: right;
      min-width: 6rem;
    }
  }
`

const tempIcon = css`
  max-width: 2rem;
  width: 100%;
  display: inline-block;
  margin-right: 0.5rem;
  vertical-align: text-bottom;
`

const trashIcon = css`
  cursor: pointer;
  width: 2.5rem;
`

const CategoryTag = styled.div({
  color: 'white',
  padding: '0.1rem 1rem',
  fontSize: '1.2rem',
  display: 'inline-block',
  borderRadius: '4px',
}, props => ({
  backgroundColor: colorPalette.itemCategories[props.color],
}))

const selectStyle = css`
  border-radius: 4px;
  padding: 0 0 0 1rem;
  margin-left: 1rem;
  background-color: ${colorPalette.background.lightgray};
  &:before {
    border: none;
  }
`